var app = angular.module("leonardo");

var ReportsFilters = function (
  $scope,
  $state,
  ngDialog,
  $rootScope,
  ReportService,
  PropertyGroupService,
  $controller
) {

  $controller('ReportsFiltersBase', { $scope: $scope });

  $scope.init = false;
  $scope.report = ReportService.getQuickReport();
  $scope.filters_valid = [];


  $scope.doFilter = function(){
    $scope.filter();
    var top = angular.element('.zone-content').offset().top - 50;
    angular.element('.wrapper-columns-column.region-main .content-column').animate({scrollTop: top}, "fast");
  };

  $scope.display = function () {
    $rootScope.$broadcast('fields-active:reset');
    if ($scope.filterService.hasFilter('group_by') && $scope.filterService.getFilter('group_by') === 'group') {
      if ($scope.filterService.hasFilter('group_reports')) {
        var groups_Ids = $scope.filterService.getFilter('group_reports').toString().split(',');
        if (groups_Ids.length > 1) {
          PropertyGroupService.getGroups(groups_Ids).then(function (data) {
            if (data) {
              ngDialog.openConfirm({
                template: 'views/templates/dialog/report/group-error.html'
              });
            }
            else {
              $scope.doFilter();
            }
          });
        }
        else {
          $scope.doFilter();
        }
      }
      else {
        PropertyGroupService.getGroups().then(function (data) {
          if (data) {
            ngDialog.openConfirm({
              template: 'views/templates/dialog/report/group-error.html'
            }).then(function () {
              // This is intentional do_something blank function
            }, function () {
              return;
            });
          }
          else {
            $scope.doFilter();
          }
        });
      }
    }
    else {
      $scope.doFilter();
    }
  };

  $scope.getValidFilters = function () {
    var filters = angular.copy($scope.filterService.filters);
    var valid_filters = {};
    var range = false;
    if (filters['unit_report_type'] === ReportService.REPORT_TYPE_REPLACEMENTS){
      filters['orientation'] = 'h';
    }
    if (!filters['group_by']) {
      filters['group_by'] = 'property';
    }
    angular.forEach(filters, function (value, key) {
      if (key === 'date_range') {
        range = true;
      }
      if (_.contains($scope.filters_valid, key)) {
        valid_filters[key] = value;
      }
    });
    if (range) {
      delete(valid_filters['from_date']);
      delete(valid_filters['to_date']);
    }
    if(!isNull(valid_filters['fields_active'])){
      if (angular.isArray(valid_filters['fields_active'])) {
        if (valid_filters['fields_active'].length > 9) {
          valid_filters['orientation'] = 'h';
        }
      }
      else {
        if (valid_filters['fields_active'].split(',').length > 9) {
          valid_filters['orientation'] = 'h';
        }
      }
    }

    if(!isNull(valid_filters['account_reports'])) {
      valid_filters['account'] = valid_filters['account_reports'];
      delete(valid_filters['account_reports']);
    }
    else {
      delete(valid_filters['account']);
    }

    if(!isNull(valid_filters['managed_by_reports'])) {
      valid_filters['managed_by'] = valid_filters['managed_by_reports'];
      delete(valid_filters['managed_by_reports']);
    }
    else {
      delete(valid_filters['managed_by']);
    }

    if (!isNull(valid_filters['group_reports'])) {
      valid_filters['group'] = valid_filters['group_reports'].toString().split(',');
      delete(valid_filters['group_reports']);
    }
    else {
      delete(valid_filters['group']);
    }

    if(!isNull(valid_filters['portfolio_reports'])) {
      valid_filters['portfolio'] = valid_filters['portfolio_reports'];
      delete(valid_filters['portfolio_reports']);
    }
    else {
      delete(valid_filters['portfolio']);
    }

    if(!isNull(valid_filters['property_reports'])) {
      valid_filters['property'] = valid_filters['property_reports'];
      delete(valid_filters['property_reports']);
    }
    else {
      delete(valid_filters['property']);
    }

    if(!isNull(valid_filters['working_days'])){
      var working_days = valid_filters['working_days'].split(',');
      if (working_days.length === 7) {
        valid_filters['working_days_all'] = true;
      }
      else{
        angular.forEach(working_days, function(field){
          valid_filters[field] = true;
        });
      }
      delete(valid_filters['working_days']);
    }
    switch($scope.report_type) {
      case ReportService.TYPE_ACTION_ITEM:
        switch (valid_filters['group_by']) {
          case 'property': valid_filters['ordering'] = 'property__name';
            break;
          case 'group': valid_filters['ordering'] = 'property__groups__name,property__name';
            break;
          case 'portfolio': valid_filters['ordering'] = 'property__portfolio__name,property__name';
            break;
          case 'account': valid_filters['ordering'] = 'property__account__name,property__portfolio__name,property__name';
            break;
          case 'managed_by': valid_filters['ordering'] = 'template__managed_by__name,property__portfolio__name,property__name';
            break;
        }
        if (!valid_filters['ordering']) {
          valid_filters['ordering'] = '';
        }
        valid_filters['ordering'] += (valid_filters['ordering'] ? ',' : '') + '-recurrence_weight,-priority,name';
        break;
      case ReportService.TYPE_ACTIVITY:
        switch (valid_filters['group_by']) {
          case 'property':
            valid_filters['ordering'] = 'property__name';
            break;
          case 'group':
            valid_filters['ordering'] = 'property__groups__name';
            break;
          case 'portfolio': valid_filters['ordering'] = 'property__portfolio__name';
            break;
          case 'account': valid_filters['ordering'] = 'property__account__name';
            break;
          case 'managed_by': valid_filters['ordering'] = 'account_user__managed_by__name';
            break;
        }
        if (!valid_filters['ordering']) {
          valid_filters['ordering'] = '';
        }
        valid_filters['ordering'] += (valid_filters['ordering'] ? ',' : '') + 'name';
        break;
      case ReportService.TYPE_CONTACT:
        if (!valid_filters['ordering']) {
          valid_filters['ordering'] = '';
        }
        valid_filters['ordering'] += 'name';
        break;
      case ReportService.TYPE_UNIT:
      case ReportService.TYPE_WORKFLOW:
        switch (valid_filters['group_by']) {
          case 'property': valid_filters['ordering'] = 'property__name';
            break;
          case 'portfolio': valid_filters['ordering'] = 'property__portfolio__name';
            break;
          case 'account': valid_filters['ordering'] = 'property__account__name';
            break;
          case 'group': valid_filters['ordering'] = 'property__groups__name';
            break;
          case 'managed_by': valid_filters['ordering'] = 'workflow__managed_by__name';
            break;
        }
        if(!valid_filters['by_unit']){
          valid_filters['by_unit'] = $scope.by_unit;
        }
        if (!valid_filters['ordering']) {
          valid_filters['ordering'] = '';
        }
        valid_filters['ordering'] += (valid_filters['ordering'] ? ',' : '') + 'name';
        break;
      case ReportService.TYPE_DYNAMIC_FORM_STATISTIC:
        switch (valid_filters['group_by']) {
          case 'property': valid_filters['ordering'] = 'property__name';
            break;
          case 'portfolio': valid_filters['ordering'] = 'property__portfolio__name';
            break;
          case 'account': valid_filters['ordering'] = 'property__account__name';
            break;
          case 'group': valid_filters['ordering'] = 'property__groups__name';
            break;
          case 'managed_by': valid_filters['ordering'] = 'workflow__managed_by__name';
            break;
        }
        if (!valid_filters['ordering']) {
          valid_filters['ordering'] = '';
        }
        valid_filters['ordering'] += (valid_filters['ordering'] ? ',' : '') + 'name';
        break;
      case ReportService.TYPE_DYNAMIC_FORM:
      case ReportService.TYPE_MIMO:
        switch (valid_filters['group_by']) {
          case 'property': valid_filters['ordering'] = 'actionitem__property__name';
            break;
          case 'portfolio': valid_filters['ordering'] = 'actionitem__property__portfolio__name';
            break;
          case 'account': valid_filters['ordering'] = 'actionitem__property__account__name';
            break;
          case 'group': valid_filters['ordering'] = 'actionitem__property__groups__name';
            break;
          case 'managed_by': valid_filters['ordering'] = 'managed_by__name';
            break;
        }
        if (!valid_filters['ordering']) {
          valid_filters['ordering'] = '';
        }
        valid_filters['ordering'] += (valid_filters['ordering'] ? ',' : '') + 'dynamic_form,modified';
        if($scope.filterService.hasFilter('include_tags'))
          valid_filters['include_tags'] = angular.isArray($scope.filterService.getFilter('include_tags')) ? $scope.filterService.getFilter('include_tags') : ($scope.filterService.getFilter('include_tags')).split(',');
        else
          delete(valid_filters['include_tags']);

        break;
      case ReportService.TYPE_BILLING:
        if (!valid_filters['ordering']) {
          valid_filters['ordering'] = 'id';
        }
        delete(valid_filters['group_by']);
        break;
      case ReportService.TYPE_TEMPLATE:
        valid_filters['has_user_activity'] = 1;
        switch (valid_filters['group_by']) {
          case 'property':
            valid_filters['ordering'] = 'property__name';
            break;
          case 'group':
            valid_filters['ordering'] = 'property__groups__name';
            break;
          case 'portfolio': valid_filters['ordering'] = 'property__portfolio__name';
            break;
          case 'account': valid_filters['ordering'] = 'property__account__name';
            break;
          case 'managed_by': valid_filters['ordering'] = 'account_user__managed_by__name';
            break;
        }
        if (!valid_filters['ordering']) {
          valid_filters['ordering'] = '';
        }
        valid_filters['ordering'] += (valid_filters['ordering'] ? ',' : '') + 'name';
        break;
      case ReportService.TYPE_PROPERTY:
        switch (valid_filters['group_by']) {
          case 'portfolio': valid_filters['ordering'] = 'portfolio__name';
            break;
          case 'account': valid_filters['ordering'] = 'account__name';
            break;
          case 'managed_by': valid_filters['ordering'] = 'managed_by__name';
            break;
        }
        if (!valid_filters['ordering']) {
          valid_filters['ordering'] = '';
        }
        valid_filters['ordering'] += (valid_filters['ordering'] ? ',' : '') + 'name';
        break;
      case ReportService.TYPE_PROPERTY_AMENITIES:
        switch (valid_filters['group_by']) {
          case 'portfolio': valid_filters['ordering'] = 'portfolio__name';
            break;
          case 'account': valid_filters['ordering'] = 'account__name';
            break;
          case 'managed_by': valid_filters['ordering'] = 'managed_by__name';
            break;
        }
        if (!valid_filters['ordering']) {
          valid_filters['ordering'] = '';
        }
        if(ReportService.getDetailsView()) {
          valid_filters['detailed'] = ReportService.getDetailsView();
        }

        var selectedOptionFieldToShow = ReportFilterService.selectedOptionFieldToShow ||  $scope.filterService.allSubFieldsGroup 
        if(valid_filters['detailed'] && !valid_filters['fields_key'] && filters.fields_active && selectedOptionFieldToShow && selectedOptionFieldToShow.length > 0){
          var field_active =  filters.fields_active.split(',');
    
          var filteredArray = selectedOptionFieldToShow
          .filter(item => {
              item.fields = item.fields.filter(field => field_active.includes(field.key));
              return item.fields.length > 0;
            })
            .map(item => item.id);
          if(filteredArray.length > 0){
            valid_filters['fields_key'] = filteredArray.join(',');
          }
        }
        
        valid_filters['ordering'] += (valid_filters['ordering'] ? ',' : '') + 'name';
        break;
      case ReportService.TYPE_USER:
        if(valid_filters['group_by'] == 'managed_by'){
          valid_filters['ordering'] = 'managed_by__name';
        }
        if (!valid_filters['ordering']) {
          valid_filters['ordering'] = '';
        }
        valid_filters['ordering'] += (valid_filters['ordering'] ? ',' : '') + 'name';
        break;
      case ReportService.TYPE_ON_DEMAND_INSTRUCTION:
        if (!valid_filters['ordering']) {
          valid_filters['ordering'] = 'name';
        }
        delete(valid_filters['group_by']);
        break;
      case ReportService.TYPE_EXISTING_DOCUMENTS:
      case ReportService.TYPE_MISSING_DOCUMENTS:
        switch (valid_filters['group_by']) {
          case 'property': valid_filters['ordering'] = 'property__name';
            break;
          case 'portfolio': valid_filters['ordering'] = 'property__portfolio__name';
            break;
          case 'account': valid_filters['ordering'] = 'property__account__name';
            break;
          case 'group': valid_filters['ordering'] = 'folder__property__groups__name';
        }
        break;
      case ReportService.TYPE_WORK_ORDERS:
        switch (valid_filters['group_by']) {
          case 'property':
            valid_filters['ordering'] = 'action_item__property__name';
            break;
          case 'group':
            valid_filters['ordering'] = 'property__groups__name';
            break;
          case 'portfolio': valid_filters['ordering'] = 'property__portfolio__name';
            break;
          case 'account': valid_filters['ordering'] = 'property__account__name';
        }
        if (!valid_filters['ordering']) {
          valid_filters['ordering'] = '';
        }
        valid_filters['ordering'] += (valid_filters['ordering'] ? ',' : '') + '-priority,action_item__name';
        break;
    }

    return valid_filters;
  };

  $scope.filter = function () {
    if (!$state.current.form) {
      $scope.init = true;
      $rootScope.$broadcast('reports:updated', $scope.getValidFilters());
    }
  };

  ReportService.doFilter = $scope.filter;

  $scope.$on('reports:filter', $scope.doFilter);

  $scope.$on('report-type:updated', function ($event, value) {
    $scope.report_type = value;
  });

  $scope.$on('$destroy', function () {
    ReportService.setQuickReport(null);
  });

};

app.controller('ReportsFilters', [
  '$scope',
  '$state',
  'ngDialog',
  '$rootScope',
  'ReportService',
  'PropertyGroupService',
  '$controller',
  ReportsFilters
]);
